<ll-titulo>Crear Evaluación Recomendada</ll-titulo>
<ll-toolnavbar>
    <evaluacion-recomendadas-toolnavbar [displayButtons]="'all'"></evaluacion-recomendadas-toolnavbar>
</ll-toolnavbar>

<evaluacion-recomendada-new [showEvaluacionMultiple]="showEvaluacionMultiple"></evaluacion-recomendada-new>
